import { PERMISSIONS } from '@helios/authz';
import { useQuery } from '@tanstack/react-query';
import { aiClient } from '@/services/aiClient';
import { sessionScopeKey, useSessionScopeFence } from './useSessionScope';
export const aiKeys = { status: ['ai', 'status'] as const };
export function useAiStatus() {
  const { identity, enabled, isCurrent } = useSessionScopeFence(PERMISSIONS.SYSTEM_AI_PROVIDERS_READ);
  const query = useQuery({ queryKey: [...aiKeys.status, ...sessionScopeKey(identity)], enabled, placeholderData: () => undefined,
    queryFn: async ({ signal }) => { if (!isCurrent(identity)) throw new Error('AI provider access required.'); const result = await aiClient.getStatus({ signal, sessionOrigin: identity.sessionOrigin }); signal.throwIfAborted(); if (!isCurrent(identity)) throw new Error('AI provider access changed while loading.'); return result; },
    staleTime: 0, refetchOnMount: 'always', refetchOnWindowFocus: 'always', retry: false,
  });
  return { ...query, data: enabled && !query.isError ? query.data : undefined };
}
